/**
 * @file Shared configuration for the XMPie Security Compliance Signup app.
 *
 * Centralises the Circle campaign API URL and access token so they are
 * defined in one place rather than duplicated across components.
 *
 * These values must match the xmpcfg object passed to <XmplProvider> in
 * index.js and the external xmpcfg.js used by the hosted build.
 */

/** Circle REST API base URL. */
export const API_URL = 'https://marketingy.xmpie.net/XMPieXMPL_REST_API';

/** Composite access token: <circleProjectID>_<secret>. */
export const ACCESS_TOKEN =
  'fead9edc-c6a4-499e-96aa-c191e7b7fb98_718401c0-4452-4516-ac61-1baef7a39978_5183b509b94e4676adcf6cf378c02093';
